module.exports = __webpack_public_path__ + "windowsHello_38x38.21687d819ff1deb56ac6c8ea30bff6e5.png";